import { withFederationConfig } from 'src/lib/components'

import LoadingState from 'src/lib/components/loadingState'
import { useGetCommunity } from 'src/modules/community/hooks/useGetCommunity'

import type { GeneralConfigProps } from './types'

import SettingsProvider from '../../context/settingsContext'
import { ErrorState } from '../errorState'
import { GeneralConfigPage } from '../generalConfigPage'

const GeneralConfig = ({ communityId, membershipSlug, generalConfigFlags }: GeneralConfigProps) => {
  const {
    communityData,
    refetch,
    isRefetching,
    isLoadingCommunityData,
    isError,
    invalidateCommunityData
  } = useGetCommunity(communityId)

  if (isLoadingCommunityData || isRefetching) return <LoadingState />

  if (isError) {
    return <ErrorState refetch={refetch} />
  }

  return (
    <SettingsProvider
      community={communityData}
      membershipSlug={membershipSlug}
      invalidateCommunityData={invalidateCommunityData}
      generalConfigFlags={generalConfigFlags}>
      <GeneralConfigPage />
    </SettingsProvider>
  )
}

export default withFederationConfig<JSX.IntrinsicAttributes & GeneralConfigProps>(
  GeneralConfig,
  true
)
